import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { containerApi } from '../..'
import { SaveWidgetsRequest, SaveWidgetsResponse } from './saveWidgets.types'

/**
 * Bulk upsert by ID. Partial payloads preserve stored order and append new
 * widgets; reordering requires every stored widget ID in the payload.
 */
export const saveWidgets = async (data: SaveWidgetsRequest) => {
  const response = await containerApi.post<SaveWidgetsResponse>(
    '/desktop/widgets',
    data
  )
  return response.data
}

export const useSaveWidgetsMutation = (
  options?: ExtendableMutationOptions<SaveWidgetsResponse, SaveWidgetsRequest>
) => {
  return useMutation({
    mutationFn: saveWidgets,
    ...options
  })
}
